import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/account";

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(form.email, form.password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate(res.user.role === "admin" ? "/admin" : from, { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <main className="page">
      <div className="page-head">
        <span className="eyebrow">Your house account</span>
        <h1>
          Sign <em>in.</em>
        </h1>
      </div>
      <form onSubmit={submit} className="checkout-form">
        <div className="form-field">
          <label>Email</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} autoComplete="email" data-testid="login-email-input" />
        </div>
        <div className="form-field">
          <label>Password</label>
          <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} autoComplete="current-password" data-testid="login-password-input" />
        </div>
        <button className="btn btn-primary" type="submit" disabled={submitting} data-testid="login-submit-button">
          {submitting ? "Signing in…" : "Sign in"} <ArrowUpRight size={14} />
        </button>
        <p style={{ color: "var(--muted)", fontSize: 13 }}>
          New here?{" "}
          <Link to="/register" className="text-link" style={{ padding: 0 }} data-testid="go-to-register-link">
            Create an account
          </Link>
        </p>
      </form>
    </main>
  );
}
